import BilanDetailContent from './component/BilanDetailContent';

// Page volontairement dépourvue du chrome applicatif (navbar, footer, breadcrumb) :
// le bilan est un document externe à la plateforme, sa page doit rester agnostique
// du look de l'app, au plus proche de l'ancien comportement window.open().
export default function BilanDetail() {
  return <BilanDetailContent />;
}
